export default __webpack_public_path__ + "static/media/effect-64.49fb3b20.mp3";